
import React, { useState, useEffect } from 'react';

import _ from 'lodash';
import { FxButton } from '../button/FxButton';
import { FxSelect } from '../select/FxSelect';
import { FxInput } from '../input/FxInput';

export const ListViewFilter = (props: any) => {
  const { filterConfig, apply, cancel, filterModel, actionApply, actionClose, actionClear, id } = props;

  //compute default model for filter
  let defaultItem: any = {}
  if (filterConfig && filterConfig.controls) {
    for (let filterControl of filterConfig.controls) {
      defaultItem[filterControl.field] = filterControl.defaultValue;
    }
    if (filterModel) {
      defaultItem = { ...defaultItem, ...filterModel };
    }
  }

  const [item, setItem] = useState(defaultItem)

  const handleInputChange = (item: any) => {
    setItem((prevState: any) => {
      return { ...prevState, ...{ [item.name]: item.value } }
    })
  }

  const applyFilter = () => {
    apply({ filterModel: item });
  }

  const onClearFilter = () => {
    for (let idx in filterConfig.controls) {
      let filter: any = filterConfig.controls[idx];
      handleInputChange({ name: filter.field, value: '' });
    }
  }

  const textFilter = (filter: any, idx: any) => {
    return <FxInput
      className="listview-filter-control"
      name={filter.field}
      label={filter.display}
      placeholder={filter.display}
      value={item[filter.field]}
      variant="outlined"
      onValueChange={handleInputChange} />
  }

  const comboFilter = (filter: any, idx: any) => {
    return <FxSelect
      className="listview-filter-control"
      name={filter.field}
      label={filter.display}
      placeholder={filter.display}
      selectedValue={item[filter.field]}
      displayField={filter.displayField}
      valueField={filter.valueField}
      options={filter.options}
      onValueChange={handleInputChange}
      variant="outlined"
    />
  }

  const filterMap: any = {
    text: textFilter,
    combo: comboFilter
  };

  const renderFilter = (filter: any, idx: any) => {
    return filterMap[filter.controlType](filter, idx);
  }

  return (
    <div id={id} className='listview-filter'>
      <div className='control-container'>
        {filterConfig && filterConfig.controls &&
          filterConfig.controls.map((filter: any, idx: number) => (
            <div id={`${id}-control-container-${idx}`} key={idx} className="filter-control-container">
              {renderFilter(filter, idx)}
            </div>
          ))}
      </div>
      <div className='d-flex justify-content-between pt-2'>
        <FxButton label={actionApply} variant="contained" onClick={applyFilter} />
        <FxButton label={actionClose} className="listviewsettings-cancel" color="error" variant="contained" onClick={cancel} />
        <FxButton label={actionClear} className="listviewsettings-cancel" color="error" variant="text" onClick={onClearFilter} />
      </div>
    </div>
  );
}

